'use client';

import { useMetrica } from 'next-yandex-metrica';
import { PropsWithChildren, useEffect } from 'react';

import { syncMetricaUser } from '../lib/sync-metrica-user';
import { useAuth } from './use-auth';

export function MetricaUserSyncProvider({ children }: PropsWithChildren) {
	const { user } = useAuth();
	const { setUserID, userParams } = useMetrica();

	useEffect(() => {
		if (user) {
			syncMetricaUser(user, { setUserID, userParams });
		}
	}, [setUserID, user, userParams]);

	return children;
}
